<template>
  <div class="local-home">
    <h1>{{ msg }}</h1>

    <p>
    空間知能化のお勉強をしましょう。
    </p>

<h2>
スマートホーム（ローカル制御）の概要：工事中
</h2>

<h4>
もくじ
</h4>

<div class="talka">
<ol>
<li>
<a href="#1">ローカル実行パス</a>
</li>
<li>
<a href="#2">動作の仕組み</a>
</li>
<li>
<a href="#3">使ってみる</a>
</li>
</ol>

</div>


<h3 id="1">
1.ローカル実行パス
</h3>

<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/local-home-sdk-execute-path.png" width="100%">
<figcaption align="center">図 1: ローカル実行パス</figcaption>
</figure>

<div class="talka">

<h4>
スマート スピーカーやスマート ディスプレイ上で JavaScript を動作させる
</h4>

<ul>
<li>
デベロッパーは、既存のスマートホーム プラットフォームをベースに、この SDK を使って Google Home スマート スピーカーや Nest スマート ディスプレイによるローカル実行パスを構築できます。
</li>
<li>
それにより、スマート端末とアシスタントとの密接な統合が実現します。
</li>
<li>
スマート スピーカーやスマート ディスプレイ上で JavaScript を動作させることで、新しいスマート端末や既存のスマート端末を制御するビジネス ロジックを実行できるので、
遅延を減らし、高い信頼性を実現して、ユーザーにメリットをもたらすことができます。
</li>
</ul>

</div>

<h3 id="2">
2.動作の仕組み
</h3>

<div class="talka">

<h4>
新しいインテント「IDENTIFY」「REACHABLE_DEVICE」の導入
</h4>

<ul>
<li>
SDK には、2 つの新しいインテント IDENTIFY と REACHABLE_DEVICES が導入されています。
</li>
<li>
ローカル ホーム プラットフォームは、mDNS、UDP、UPnP を使ってユーザーのホーム ネットワークをスキャンし、アシスタントに接続されているスマート端末を検出します。
</li>
<li>
そして、IDENTIFY を呼び出し、端末 ID がおなじみの Smart Home API の SYNC インテントから返される端末 ID と一致することを検証します。
</li>
<li>
検出した端末がハブまたはブリッジだった場合は、REACHABLE_DEVICES が呼び出され、ハブはローカル通信のプロキシ端末として扱われます。
</li>
<li>
Google Home から端末へのローカル実行パスが確立すると、ホームグラフの端末プロパティが更新されます。
</li>
</ul>


<figure style="max-width: 640px;">
<img src="http://www.hiroict.com/img/akiko/homegraph.png" width="100%">
<figcaption align="center">図 2: それぞれの実行パスに使われるインテント</figcaption>
</figure>

<h4>
アシスタントは、Google Nest 端末に EXECUTE インテントを送る
</h4>

<ul>
<li>
ユーザーがローカル実行パスを持つスマートホームの Action を呼び出すと、アシスタントはデベロッパーのクラウド フルフィルメントではなく、Google Nest 端末に EXECUTE インテントを送ります。
</li>
<li>
デベロッパーの JavaScript アプリが起動し、そのアプリが Local Home SDK を呼び出し、TCP、UDP ソケット、HTTP/HTTPS リクエストのいずれかを使ってスマート端末に制御コマンドを送ります。
</li>
<li>
クラウドではなくローカル実行をデフォルトにすることで、ユーザーのリクエストに迅速に対応できます。
</li>
<li>
ローカル実行が失敗した場合、実行リクエストはクラウドパスに送られます。
</li>
<li>
この冗長性により、リクエストが失敗する可能性を最低限に抑えることができるので、全体的なユーザー エクスペリエンスが向上します。
</li>
</ul>

<h4>
Local Home プラットフォームの他の機能
</h4>

<ul>
<li>
他にも、Local Home プラットフォームには次のような機能があります。
</li>
<li>
2 段階認証を有効化することなく、Wi-Fi 対応の端末タイプと端末特性をすべてサポート
</li>
<li>
ユーザーがアクションを行わなくても、すべての端末で Local Home を利用可能
</li>
<li>
検出プロトコルとホストする JavaScript アプリの URL を Actions コンソールから簡単に設定
</li>
</ul>

<h4>
JavaScript アプリの開発
</h4>

<ul>
<li>
JavaScript アプリは端末上でテストできるので、デベロッパーは Chrome Developer Console などのおなじみのツールを使ってデバッグできます。
</li>
<li>
また、Local Home SDK は既存のスマートホーム フレームワークと連携して動作するので、新しいアプリはスマートホーム用テストスイートを使って自己検証することもできます。
</li>
</ul>


</div>


<h3 id="3">
3.使ってみる
</h3>

<ul>
<li>
Local Home プラットフォームの詳細については、<a href="https://developers.google.com/assistant/smarthome/reference/local#local-home-sdk-reference">API リファレンス</a>をご覧ください。
</li>
<li>
また、<a href="https://developers.google.com/assistant/smarthome/concepts/local">デベロッパー ガイド</a>や<a href="https://github.com/actions-on-google/smart-home-local">サンプル</a>を参考にして、ローカル実行を試してみてください。
</li>
<li>
スマート端末を Google アシスタントに接続する方法など、汎用的な情報については、スマートホームのドキュメントにアクセスするか、今年の Google I/O でお話ししたスマートホーム向けのローカル テクノロジーについて確認してください。
</li>
<li>
フィードバックは、バグトラッカーから送ることができます。または、/r/GoogleAssistantDev からコミュニティにお知らせいただいても構いません。
</li>
<li>
ディスカッションを整理するために、投稿には local-home-sdk タグを付けてください。
</li>
</ul>

<div class="talka">

</div>



  </div> <!-- end of local-home -->

</template>

<script>
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

export default {
  name: 'DanceWorld',
  props: {
    msg: String
  },
  data() {
    return {
      //album_index: 0,
      //album_title : 'ワルツ',
      //video_index: 0,
      //video_title : '01 いきいきストレッチング',

      //video_index_1: 0,
      //video_id: '5IlfzLYadNk',

      //albums: [],
    }
  },
  created () {
    //this.albums = [this.album_1, this.album_2, this.album_3, this.album_4, this.album_5, this.album_6, this.album_7]
    //this.firstVideo()
  },
  methods: {
    /*
    selectAlbum(index) {
      window.console.log("selectAlbum() 1.index: " + index);
      this.album_index = index;
      this.firstVideo()
    },
    */
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smart-display {
  //margin-left: 20px;
}

.talka {
  margin-left: 10px;
}

pre {
background-color: #ffffaa;
}

h3 {
  margin: 40px 0 0;
}
ol {
  //list-style-type: none;
  padding: 0;
}
ul {
  //list-style-type: none;
  margin-left: 20px;
  padding: 0;
}
li {
  //display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
